<ion-header>
  <div class="flex items-center justify-between px-6 py-4">
    <lib-icon name="cancel" class="text-2xl text-gray-600 cursor-pointer" (click)="cancel()"></lib-icon>
    <h2 class="text-lg font-semibold text-gray-800 font-title">{{ title }}</h2>
    <lib-icon name="check-mark" class="text-2xl text-teal-500 cursor-pointer" (click)="confirm()"></lib-icon>
  </div>
  <!-- Buscador -->
  <div class="px-4 pb-3">
    <div class="relative">
      <lib-icon name="search"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-xl text-gray-400 pointer-events-none"></lib-icon>
      <input type="text" class="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 dark:border-gray-700
               bg-gray-50 dark:bg-gray-800 text-sm font-title text-gray-800 dark:text-white
               placeholder:text-gray-400 focus:outline-none focus:border-teal-400
               transition-colors duration-150" placeholder="Buscar por nombre" [value]="searchQuery()"
        (input)="onSearchChange($event)" />
    </div>
  </div>
</ion-header>

<ion-content>
  <ion-list lines="none" class="py-1">

    <!-- Seleccionar / Deseleccionar todos -->
    <ion-item button detail="false" (click)="toggleSelectAll()" class="mb-1">
      <ion-checkbox class="border-amber-50" slot="start" [checked]="isAllSelected()"
        [indeterminate]="workingSelected().length > 0 && !isAllSelected()" (click)="$event.stopPropagation()"
        (ionChange)="toggleSelectAll()"
        style="--border-color: #d1d5db; --checkmark-color: white; --border-radius: 6px; --border-width: 1px;"></ion-checkbox>
      <label class="ml-3 font-title  text-sm font-semibold text-gray-900 dark:text-white">
        {{ isAllSelected() ? deselectAllLabel : selectAllLabel }}
      </label>
    </ion-item>

    <div class="mx-4 mb-1 border-b border-gray-200 dark:border-gray-700"></div>

    <!-- Opcions filtrades -->
    @for (option of filteredOptions(); track option.value) {
    <ion-item [class.opacity-40]="option.disabled">
      <lib-checkbox label="{{option.label}}" [checked]="isSelected(option.value)"
        (checkedChange)="toggleOption(option.value)">
      </lib-checkbox>
    </ion-item>
    }

    @if (filteredOptions().length === 0) {
    <div class="py-8 text-center">
      <p class="font-title text-sm text-gray-400">Sin resultados</p>
    </div>
    }

  </ion-list>
</ion-content>

<ion-footer class="ion-no-border">
  <div class="px-4 py-2 border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 text-center">
    @if (workingSelected().length > 0) {
    <span class="text-xs font-medium text-teal-600 dark:text-teal-400 font-title">
      {{ workingSelected().length }} seleccionado{{ workingSelected().length !== 1 ? 's' : '' }}
    </span>
    } @else {
    <span class="text-xs text-gray-400 font-title">Ninguno seleccionado</span>
    }
  </div>
</ion-footer>